import React from 'react';
import {Route, Routes, useLocation} from 'react-router-dom';
import Layout from "./components/layout/Layout";
import {HomePage} from "./pages/HomePage";
import LifestylePage from "./pages/LifestylePage";
import SportsPage from "./pages/SportsPage";
import RestaurantPage from "./pages/RestaurantPage";
import JuniorPage from "./pages/JuniorPage";
import HospitalityPage from "./pages/HospitalityPage";
import MembershipPage from "./pages/MembershipPage";
import ConnectPage from "./pages/ConnectPage";
import {AnimatePresence} from "framer-motion";
import PageWrapper from "./components/layout/PageWrapper";
import AboutPage from "./pages/AboutPage";

const App: React.FC = () => {
    const location = useLocation();

    return (
        <AnimatePresence mode="sync" initial={false}>
            <Routes location={location} key={location.pathname}>
                <Route path="/" element={<Layout/>}>
                    <Route index element={<PageWrapper><HomePage/></PageWrapper>}/>
                    <Route path="/about" element={<PageWrapper><AboutPage/></PageWrapper>}/>
                    <Route path="/lifestyle-and-wellness" element={<PageWrapper><LifestylePage/></PageWrapper>}/>
                    <Route path="/sports-facilities" element={<PageWrapper><SportsPage/></PageWrapper>}/>
                    <Route path="/restaurants-and-bars" element={<PageWrapper><RestaurantPage/></PageWrapper>}/>
                    <Route path="/junior-engagement" element={<PageWrapper><JuniorPage/></PageWrapper>}/>
                    <Route path="/hospitality" element={<PageWrapper><HospitalityPage/></PageWrapper>}/>
                    <Route path="/membership" element={<PageWrapper><MembershipPage/></PageWrapper>}/>
                    <Route path="/connect" element={<PageWrapper><ConnectPage/></PageWrapper>}/>
                </Route>
            </Routes>
        </AnimatePresence>
    );
};

export default App;
